module.exports = __webpack_public_path__ + "ad9bddfb5a7e85f836a39422b479de84.png";